import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

// Универсальный чип статуса. Цвет подтягивается из класса Tailwind через union tone.
export type Tone = 'accent' | 'green' | 'amber' | 'red' | 'muted';

// Светлая тема: подложка - тот же токен на 10% (пастель), текст - он же в полную силу.
// 10% - это ровно тот тинт, под который посчитаны значения статусов: пара «цвет на своей
// подложке» держит 4.5:1 даже на самой тёмной поверхности (panel2). Плотнее тинт делать
// нельзя - текст на нём просядет ниже нормы. См. ui-base.css и ui-contrast.spec.ts.
// Границы у чипа нет намеренно: в прототипе чип - мягкое пятно, а не обведённая плашка.
const TONES: Record<Tone, string> = {
  accent: 'bg-accent/10 text-accent-fg',
  green: 'bg-green/10 text-green',
  amber: 'bg-amber/10 text-amber',
  red: 'bg-destructive/10 text-destructive',
  muted: 'bg-panel2 text-muted',
};

export function StatusChip({
  tone = 'muted',
  children,
  className,
  title,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  /** Native HTML title - показывается как tooltip при наведении. */
  title?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[12px] font-semibold whitespace-nowrap',
        TONES[tone],
        className,
      )}
      data-slot="status-chip"
      title={title}
    >
      {children}
    </span>
  );
}
